import {
    ORDER_COUNT,
    SC_HOST_INFOR,
    PERSONAL_INFOR,
    MY_BACKUP_LIST,
    SUPPLY_CENTER_LIST,
    UPDATE_BACKUP_LIST,
    GET_ALPHA_LIST,
    GET_INVENTORY_BY_SKU_AND_SC,
    SYS_DICT,
    UPDATE_SUPPLY_CENTER_LIST,
    GET_SYSTEM_NOTIFICATION,
    SET_SYSTEM_NOTIFICATION,
} from 'Actions/userCenter';
import update from 'immutability-helper';
const initialState = {};

export function userCenter(state = initialState, action) {
    let payload = {};

    switch (action.type) {
        case ORDER_COUNT:
            payload = action.payload;

            return Object.assign({}, state, {myOrderCount: payload});
        case SC_HOST_INFOR:
            payload = action.payload;

            return Object.assign({}, state, {scHostInfor: payload});
        case PERSONAL_INFOR:
            payload = action.payload;

            return Object.assign({}, state, {personalInfor: payload});
        case UPDATE_BACKUP_LIST:
            return update(state, {backupList: action.payload});
        case MY_BACKUP_LIST:
            if (action.payload.pageNum === 1)
                payload.backupList = action.payload.data;
            if (action.payload.pageNum > 1) {
                payload.backupList = state.backupList.concat(
                    action.payload.data,
                );
            }

            return {...state, ...payload};

        case GET_SYSTEM_NOTIFICATION:
            payload.systemNotification = action.payload.data;

            return {...state, ...payload};

        case SET_SYSTEM_NOTIFICATION:
            return update(state, {systemNotification: action.payload});

        case SUPPLY_CENTER_LIST:
            payload.SCList = action.payload;

            return {...state, ...payload};

        case UPDATE_SUPPLY_CENTER_LIST:
            payload.SCList = action.payload;

            return {...state, ...payload};

        case GET_ALPHA_LIST:
            payload.alphaList = action.payload;

            return {...state, ...payload};
        case GET_INVENTORY_BY_SKU_AND_SC:
            payload.inventoryInfor = action.payload;

            return {...state, ...payload};
        case SYS_DICT:
            payload = action.payload.data;

            return Object.assign({}, state, {backupReasonList: payload});
        default:
            return state;
    }
}
